export default () => {
  // elements
  const els = {
    bar: document.querySelector('[data-announcement]'),
    header: document.querySelector('[data-new-layout-header]'),
    close: document.querySelector('[data-announcement-close]'),
    body: document.body,
  };

  const classes = {
    bodyAnnouncementShow: 'body--announcement-show',
  };

  const announcementIsHidden = window.sessionStorage.getItem(
    'hide-announcement-bar'
  );

  if (els.bar && els.header) {
    const announcementBarHeight = els.bar.offsetHeight;
    const navbarHeight = els.header.offsetHeight;
    //functions
    const showAnnouncement = () => {
      els.bar.style.maxHeight = `${els.bar.scrollHeight}px`;
      els.body.classList.add(classes.bodyAnnouncementShow);
      let headerSection = document.querySelector('header.section-header');
      if (headerSection) {
        headerSection.style.height = announcementBarHeight + navbarHeight + 'px';
      }
      window.sessionStorage.setItem('hide-announcement-bar', false);
      enableMarqueeIfNeeded();
    };

    const hideAnnouncement = () => {
      els.bar.style.maxHeight = 0;
      window.sessionStorage.setItem('hide-announcement-bar', true);
      let headerSection = document.querySelector('header.section-header');
      if (headerSection) {
        headerSection.style.height = navbarHeight + 'px';
      }
      els.body.classList.remove(classes.bodyAnnouncementShow);
    };

    // Marquee logic
    function enableMarqueeIfNeeded() {
      const marquee = els.bar.querySelector('.announcement__marquee');
      if (!marquee) return;
      const text = marquee.querySelector('.announcement__text');
      if (!text) return;
      
      // Only enable marquee if text is wider than container
      if (text.scrollWidth > marquee.offsetWidth) {
        marquee.classList.add('marquee-active');
        
        // Calculate animation duration based on text length
        // Reading speed: ~200-250 words per minute = ~3-4 words per second
        // For scrolling text, we want it slower for readability
        const textWidth = text.scrollWidth;
        const gapWidth = 100; // 100px gap between cycles
        
        // Base reading speed: 1 second per 50px of text (adjustable)
        const baseSpeed = 70; // pixels per second
        const pauseTime = 0.5; // seconds to pause at start and end
        
        // For continuous marquee with gap, we animate the full text width plus gap
        const totalDistance = textWidth + gapWidth;
        const animationDuration = Math.max(8, totalDistance / baseSpeed) + (pauseTime * 2);
        
        // Set the text content as data attribute for the ::after pseudo-element
        text.setAttribute('data-text', text.textContent);
        
        // Set custom CSS property for dynamic animation duration
        marquee.style.setProperty('--marquee-duration', `${animationDuration}s`);
      } else {
        marquee.classList.remove('marquee-active');
        marquee.style.removeProperty('--marquee-duration');
      }
    }

    // event listeners
    els.close.addEventListener('click', (e) => {
      e.preventDefault();
      hideAnnouncement();
    });

    // init
    if (!announcementIsHidden || announcementIsHidden === 'false') {
      showAnnouncement();
    } else {
      hideAnnouncement();
    }

    // Run marquee check on resize
    window.addEventListener('resize', enableMarqueeIfNeeded);
    // Also run after DOM is loaded in case of dynamic content
    window.addEventListener('DOMContentLoaded', enableMarqueeIfNeeded);
  }
};
